import { useMutation, useQuery, useQueryClient } from 'react-query';
import { SignatureRequestInterface } from './ChecklistSignature.types';
import { createSignature, getSignature } from './ChecklistSignature.service';
import notificationError from '@/utils/functions/notificationError';

export function useSignature(params: SignatureRequestInterface) {
  const response = useQuery(
    ['checklist-signature', params],
    () => getSignature(params),
    { onError: (error) => notificationError(error) },
  );
  return response;
}

export function useCreateSignature() {
  const queryClient = useQueryClient();
  const mutation = useMutation(createSignature, {
    async onSuccess() {
      await queryClient.invalidateQueries(['workorder/checklistReportPublic']);
      await queryClient.invalidateQueries(['checklist-signature']);
    },
    onError(error) {
      notificationError(error);
    },
  });
  return mutation;
}
